import {FC, useState} from 'react'
import ReactSlider from 'react-slider'
import {isServiceActive} from "../../../lib/booking";

interface Props {
    title: string,
    type:string,
    active?:boolean,
    handle:Function,
    radio?:boolean
}

const CheckBox: FC<Props> = ({ title, type, active, handle, radio}) => {
    const handleClick = () => {
        if(radio)
            active = false

        handle(type, !active)
    }

    const className = 'checkbox ' + (active ? 'checked' : '')
    return (
        <div className={className} onClick={() => handleClick()}>
            <div className="box"/>
            <p>{title}</p>
        </div>
    )
};

export default CheckBox
